import React from "react";

/**
 * @component ProjectStarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ProjectStarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectStarIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ProjectStarIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 15v5h5v-5H4zm0-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2v-5a2 2 0 012-2zm11-9v5h5V4h-5zm0-2h5a2 2 0 012 2v5a2 2 0 01-2 2h-5a2 2 0 01-2-2V4a2 2 0 012-2zm0 13v5h5v-5h-5zm0-2h5a2 2 0 012 2v5a2 2 0 01-2 2h-5a2 2 0 01-2-2v-5a2 2 0 012-2z"
      />
      <path d="M6.505 9.631L4.198 10.9a.429.429 0 01-.592-.193.477.477 0 01-.044-.29l.44-2.687-1.865-1.903a.474.474 0 01-.008-.649.432.432 0 01.251-.133l2.578-.392 1.153-2.445a.43.43 0 01.787 0L8.05 4.653l2.578.392c.24.036.406.269.371.52a.467.467 0 01-.128.262L9.006 7.73l.44 2.686a.456.456 0 01-.357.53.42.42 0 01-.278-.046L6.505 9.63z" />
    </svg>
  )
);
ProjectStarIcon.displayName = "ProjectStarIcon";
export default ProjectStarIcon;
